import { Currency } from "@redotech/money/currencies";
import {
  CoverageText,
  NonCoverageButtonText,
  TitleSubtitle,
  WidgetFees,
} from "@redotech/redo-model/widget";
import { CURRENCY_FORMAT } from "@redotech/redo-web/currency";

export function fillTemplateVariables({
  text,
  currency,
  coveragePrice,
  cartTotal,
}: {
  text: string;
  currency: Currency;
  coveragePrice: number;
  cartTotal: number;
}): string {
  let textWithVariables = text.replaceAll(
    "%price%",
    CURRENCY_FORMAT(currency || "USD").format(coveragePrice),
  );
  textWithVariables = textWithVariables.replaceAll(
    "%cartTotal%",
    CURRENCY_FORMAT(currency || "USD").format(cartTotal),
  );
  textWithVariables = textWithVariables.replaceAll(
    "%combinedPrice%",
    CURRENCY_FORMAT(currency || "USD").format(coveragePrice + cartTotal),
  );

  return textWithVariables;
}

export function getTextByProduct(
  textByProduct: NonCoverageButtonText | undefined,
  {
    fees,
    hasProtectionReturnsAndSplit,
    cartEligibleProtection,
    cartEligibleReturns,
    currency,
    coveragePrice,
    cartTotal,
  }: {
    fees: WidgetFees;
    hasProtectionReturnsAndSplit: boolean;
    cartEligibleReturns: boolean;
    cartEligibleProtection: boolean;
    currency: Currency;
    coveragePrice: number;
    cartTotal: number;
  },
): string | undefined {
  if (!textByProduct) {
    return undefined;
  }

  const { returns, packageProtection, both } = textByProduct;

  let finalText: string | undefined;
  if (fees.mainType === "return") {
    finalText = returns;
  } else if (fees.mainType === "return,package_protection") {
    finalText = both;
  } else if (fees.mainType === "package_protection") {
    finalText = packageProtection;
  }

  if (hasProtectionReturnsAndSplit) {
    if (cartEligibleReturns && cartEligibleProtection) {
      finalText = both;
    } else if (cartEligibleProtection) {
      finalText = packageProtection;
    } else {
      finalText = returns;
    }
  }

  if (finalText) {
    finalText = fillTemplateVariables({
      text: finalText,
      currency,
      coveragePrice,
      cartTotal,
    });
  }

  return finalText;
}

export function getCoverageTextAndSubtext(
  coverageText: CoverageText | undefined,
  textInfo: {
    fees: WidgetFees;
    hasProtectionReturnsAndSplit: boolean;
    cartEligibleReturns: boolean;
    cartEligibleProtection: boolean;
    currency: Currency;
    coveragePrice: number;
    cartTotal: number;
  },
): TitleSubtitle {
  if (!coverageText) {
    return {};
  }

  const titleText: string | undefined = getTextByProduct(
    {
      returns: coverageText.returns?.titleText,
      packageProtection: coverageText.packageProtection?.titleText,
      both: coverageText.both?.titleText,
    },
    textInfo,
  );
  const subtitleText: string | undefined = getTextByProduct(
    {
      returns: coverageText.returns?.subtitleText,
      packageProtection: coverageText.packageProtection?.subtitleText,
      both: coverageText.both?.subtitleText,
    },
    textInfo,
  );

  return { titleText, subtitleText };
}
